@if (loading) {
  <div class="loading-container flex-content-center" aria-busy="true" aria-live="polite">
    <mat-progress-spinner color="primary" mode="indeterminate" aria-label="Loading..."></mat-progress-spinner>
  </div>
}

@if (loginDisplay) {
  <app-main-nav></app-main-nav>
} @else {
  <router-outlet></router-outlet>
}